module.exports = __webpack_public_path__ + "static/christmas_childplay_1963.cd404bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_childplay_1963.jpg
// module id = 505
// module chunks = 142966368958528